<template>
  <div style="position: relative;">
    <canvas :id="idcanvas" style="width: auto !important;"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "ChartJs-Comp",
  props: {
    config: {
      type: Object,
    },
    cambio: Number,
  },
  data() {
    return {
      idcanvas: "",
      chart: null,
      data: {},
      colorbase: [
        "#293462",
        "#f76262",
        "#216583",
        "#aee7e8",
        "#28c3d4",
        "#fbc99d",
        "#ed1250",
        "#10ddc2",
        "#042f4b",
        "#15b7b9",
        "#f57170",
        "#248ea9",
      ],
      example: {
        type: "line",
        data: {
          labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
          datasets: [
            {
              label: "# of Votes",
              data: [12, 19, 3, 5, 2, 3],
              borderWidth: 1,
            },
            {
              label: "# of Points",
              data: [7, 11, 5, 8, 3, 7],
              borderWidth: 1,
            },
          ],
        },
        options: {
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "y-axis-0",
                value: "5",
                borderColor: "red",
                borderWidth: 2,
              },
            ],
          },
        },
      },
    };
  },
  created() {
    this.idcanvas = Math.random()
      .toString(36)
      .substr(2, 9);
  },
  mounted() {
    if (this.config && this.config.data) {
      this.render(this);
    } else {
      console.error(
        "La configuración del gráfico no está completa:",
        this.config
      );
    }
  },
  methods: {
    render(_this) {
      Chart.defaults.global.defaultFontFamily = "'Montserrat', sans-serif"; // Tipo de letra
      Chart.defaults.global.tooltips.backgroundColor = "rgba(45, 64, 89, 0.9)"; // Fondo del tooltip
      Chart.plugins.unregister(ChartDataLabels);

      const ctx = document.getElementById(_this.idcanvas).getContext("2d");

      const data = {
        type: _this.config.type || "line",
        data: _this.config.data || {},
        options: _this.config.options || {},
        plugins: _this.config.plugins || [],
      };

      if (_this.chart) {
        _this.chart.destroy();
      }
      _this.chart = new Chart(ctx, data);
    },
  },
  watch: {
    cambio(newv, oldv) {
      if (this.config) {
        this.render(this);
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/GraphChartJs.vue